import styled from 'styled-components';
import { SkeletonBase } from '../../../UIelements/Skeleton/styles';

export const Card = styled.div`
  box-shadow: 0 0 0.7em ${({ theme }) => theme.colors.boxShadow};
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionTitle = styled(SkeletonBase)`
  height: 24px;
  width: 30%;
`;

export const ExpandPlaceholder = styled(SkeletonBase)`
  height: 20px;
  width: 80px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 0.7fr) 1fr;
  gap: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const PanelTitle = styled(SkeletonBase)`
  height: 18px;
  width: 40%;
`;

export const DoughnutPlaceholder = styled(SkeletonBase)`
  width: 220px;
  height: 220px;
  border-radius: 50%;
`;

export const TableTitle = styled(SkeletonBase)`
  height: 24px;
  width: 40%;
`;
